import { useTheme as useMuiTheme } from '@mui/material/styles';

/**
 * Custom hook to access theme values with convenient shortcuts
 *
 * @returns {Object} Theme object with convenient shortcuts
 */
export const useRsmTheme = () => {
  const theme = useMuiTheme();

  return {
    ...theme,
    colors: {
      // Primary brand colors
      primary: theme.palette.primary.main, // #779A0A
      primaryLight: theme.palette.primary.light, // #b5da5f
      primaryDark: theme.palette.primary.dark, // #597307

      // Secondary brand colors
      secondary: theme.palette.secondary.main, // #1A1A1A
      secondaryLight: theme.palette.secondary.light,
      secondaryDark: theme.palette.secondary.dark,

      // Background colors
      background: theme.palette.background.default, // #ffffff
      backgroundPaper: theme.palette.background.paper,
      backgroundDark: theme.palette.background.dark, // #1A1A1A
      backgroundLight: theme.palette.background.light, // #f8f9fa

      // Text colors
      textPrimary: theme.palette.text.primary, // #1A1A1A
      textSecondary: theme.palette.text.secondary, // #ffffff
      textMuted: theme.palette.text.muted, // #6c757d
      textLight: theme.palette.text.light, // #4a4a4a

      // Grey scale
      grey50: theme.palette.grey[50], // #f8f9fa
      grey100: theme.palette.grey[100], // #e9ecef
      grey200: theme.palette.grey[200], // #dee2e6
      grey300: theme.palette.grey[300], // #ced4da
      grey400: theme.palette.grey[400], // #adb5bd
      grey500: theme.palette.grey[500], // #6c757d
      grey600: theme.palette.grey[600], // #495057
      grey700: theme.palette.grey[700], // #343a40
      grey800: theme.palette.grey[800], // #212529
      grey900: theme.palette.grey[900], // #1A1A1A
    },
    spacing: {
      xs: theme.spacing(1), // 8px
      sm: theme.spacing(2), // 16px
      md: theme.spacing(3), // 24px
      lg: theme.spacing(4), // 32px
      xl: theme.spacing(6), // 48px
      xxl: theme.spacing(8), // 64px
    },
    shadows: {
      card: '0 4px 20px rgba(0, 0, 0, 0.08)',
      cardHover: '0 12px 40px rgba(0, 0, 0, 0.15)',
      button: '0 8px 24px rgba(119, 154, 10, 0.3)',
      buttonHover: '0 12px 36px rgba(119, 154, 10, 0.4)',
    },
  };
};
